import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../screens/content/home";
import NotFound from "../screens/content/notFound";
import ScrollToTop from "./scrollToTop";
import { isBrowserDefined } from "../shared/services/browserService";
import CustomLayout from "../screens/customLayout";
import "../translation/index";
import { screens } from "../config/routes";
import { store } from "../redux/store";
import { Provider } from "react-redux";
import AnimatedCursor from "../components/animatedCursor";
import LandDetails from "../screens/content/landDetails";
import Lands from "../screens/content/lands";
import useDeviceType from "../shared/hooks/useDeviceType";
import { DeviceTypes } from "../shared/utils/enums";

/**
 * MainRouter component that handles the routing for the application.
 *
 * This component sets up the routes and ensures that the scroll restoration behavior is set to manual
 * when the application is running in a browser environment. It also wraps the routes with a Redux Provider
 * and a custom layout.
 *
 * @returns {JSX.Element} The MainRouter component.
 */
const MainRouter = (): JSX.Element => {
  const deviceType = useDeviceType();
  useEffect(() => {
    if (isBrowserDefined()) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <Provider store={store}>
      <CustomLayout>
        {isBrowserDefined() && <ScrollToTop />}
        {isBrowserDefined() && deviceType !== DeviceTypes.mobile && (
          <AnimatedCursor
            color="22, 23, 37" // RGB color values
            outerAlpha={0.4}
            outerSize={8}
            outerScale={5}
          />
        )}
        <Routes>
          <Route path={screens.home} element={<Home />} />
          <Route path="/home" element={<Navigate to="/" />} />
          <Route path={screens.landDetails} element={<LandDetails />} />
          <Route path={screens.lands} element={<Lands />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </CustomLayout>
    </Provider>
  );
};

export default MainRouter;
